﻿function PleaseWait(msg) {
    const fancybox = new Fancybox([
        {
            src: "<div class='wait-popup'><img alt='please wait cursor' src='https://humankinetics.myshopify.com/cdn/shop/files/loading.gif' ></img><h4>Please Wait...</h4><h6>" + msg + "</h6></div >",
            type: "html",
        },
    ]);
}
function HideWait() {
    Fancybox.close();
}

function ShowResult(errorMsg) {
    const fancybox = new Fancybox([
        {
            src: "<p>" + errorMsg + "</p><p><a class='btn btn--primary' href='#' onClick='HideWait(); return false;'>Close</a></p>",
            type: "html",
            closeButton: true
        },
    ]);
}

function sanitizeInput(input) {
    return input.replace(/[:;]/g, " -") // Replace colon and semicolon with hyphen
        .replace(/\\/g, "\\\\")  // Escape backslashes
        .replace(/"/g, '\\"')    // Escape double quotes
        .replace(/'/g, "\\'")    // Escape single quotes
        .replace(/&/g, "and")    // Replace & with "and"
        .replace(/[\[\]]/g, " ") // Replace square brackets with spaces
        .replace(/[^a-zA-Z0-9 \-.,'&]/g, " "); // Remove remaining special characters
}